import {
  listProfiles,
  getProfile,
  createProfile,
  updateProfile,
  deleteProfile,
  importProfile,
  exportProfile
} from "@/apis/profiles";

const handleResponse = (response) => {
  if (response?.status?.toLowerCase() === "error") {
    throw new Error(response.error || response.message);
  } else {
    return response.value;
  }
};


export const ProfilesDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    const response = await listProfiles();
    const data = response.value;
    return {
      data,
      total: data.length,
    };
  },
  getOne: async ({ id, meta }) => {
    if (!id) {
      return null;
    }
    
    const resp = await getProfile(id);
    return resp.value;
    
  },
  create: async ({variables, meta }) => {
    const result = await createProfile(variables);
    return { result };
  },
  update: async ({ id, variables }) => {
    const resp = await updateProfile(id, variables);
    return handleResponse(resp);
  },
  deleteOne: async ({ resource, id }) => {
    const resp = await deleteProfile(id);
    return resp.value;
  },
  getApiUrl: () => {
    throw new Error("Function not implemented.");
  },
};
